import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9636dc1a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"
import style1 from "./style.scss?vue&type=style&index=1&id=9636dc1a&scoped=true&lang=scss&"
import style2 from "./index.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9636dc1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/bsx-uat.dianthus.com.tw/backstage_orig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9636dc1a')) {
      api.createRecord('9636dc1a', component.options)
    } else {
      api.reload('9636dc1a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9636dc1a&scoped=true&", function () {
      api.rerender('9636dc1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/vueFormFieldComponents/fieldQuillEditor/index.vue"
export default component.exports